<style>
  .split {
    display: flex;
    justify-content: space-between;
    margin: -4px;
    padding: 4px;
  }
  .active {
    color: #fff;
    background: #333;
    margin: 4px -4px;
  }
</style>

<article class="card full opening-times">
  <h2 class="title">Öffnungszeiten</h2>
  <div class="description">
    <div class="split" class:active="{today === 1}">
      <span>Montag:</span>
      <span><time datetime="15:00:00">15:00</time> - <time datetime="18:30:00">18:30</time> Uhr</span>
    </div>
    <div class="split" class:active="{today === 2}">
      <span>Dienstag:</span>
      <span><time datetime="15:00:00">15:00</time> - <time datetime="18:30:00">18:30</time> Uhr</span>
    </div>
    <div class="split" class:active="{today === 3}">
      <span>Mittwoch:</span>
      <span><time datetime="15:00:00">15:00</time> - <time datetime="18:30:00">18:30</time> Uhr</span>
    </div>
    <div class="split" class:active="{today === 4}">
      <span>Donnerstag:</span>
      <span><time datetime="15:00:00">15:00</time> - <time datetime="18:30:00">18:30</time> Uhr</span>
    </div>
    <div class="split" class:active="{today === 5}">
      <span>Freitag:</span>
      <span><time datetime="15:00:00">15:00</time> - <time datetime="18:30:00">18:30</time> Uhr</span>
    </div>
    <div class="split" class:active="{today === 6}">
      <span>Samstag:</span>
      <span><time datetime="15:00:00">10:00</time> - <time datetime="12:30:00">12:30</time> Uhr</span>
    </div>
    <div class="split" class:active="{today === 0}">
      <span>Sonntag:</span>
      <span>Geschlossen</span>
    </div>
  </div>
</article>

<script>
  let today = new Date().getDay();
</script>
